<template>
  <div class="modal-backdrop">
    <section class="modal-panel" role="dialog" aria-modal="true" aria-labelledby="document-save-conflict-title">
      <header class="modal-header">
        <h2 id="document-save-conflict-title" class="modal-title">Save conflict</h2>
      </header>
      <div class="modal-body">
        <p class="modal-message">
          {{ conflict.title }} was changed by {{ actorName }} at {{ savedAt }}.
        </p>
      </div>
      <footer class="modal-footer">
        <button type="button" class="btn btn-ghost" @click="$emit('rollback')">Rollback my changes</button>
        <button type="button" class="btn btn-primary" @click="$emit('overwrite')">Overwrite with my version</button>
      </footer>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { DocumentSaveConflict } from '../stores/workspace';

const props = defineProps<{
  conflict: DocumentSaveConflict;
}>();

defineEmits<{
  overwrite: [];
  rollback: [];
}>();

const actorName = computed(() => props.conflict.serverLastModifiedByUserName || 'another user');
const savedAt = computed(() => new Date(String(props.conflict.serverSavedAt)).toLocaleString());
</script>
